import { defineMessages } from 'react-intl';

export default defineMessages({
  doneCustomizingLabel: {
    id: 'ordering.productDetails.customizations.doneCustomizingLabel',
    defaultMessage: 'Done customizing',
    description: 'The label value for the done customizing button',
  },
});
